'use strict';

function WebglMapDirective () {

  var link = function () {};

  return {
    scope: {},
    bindToController: true,
    controller: 'WebglMapController',
    controllerAs: 'vm',
    link,
    templateUrl: 'dash/webglMap/webglMap.tpl.html'
  };
}

WebglMapDirective.$inject = [];

module.exports = WebglMapDirective;



// WEBPACK FOOTER //
// ./src/app/dash/webglMap/WebglMapDirective.js